export type TimeZone = {
  countryName: string;
  countryCode: string;
  comment: string;
  offset: number;
} & Entity;

export type TimeZone$Labeled = {
  label: string;
} & TimeZone;

export const PREDEFINED_ZONES = [
  'Atlantic/Azores',
  'Atlantic/South_Georgia',
  'America/Sao_Paulo',
  'America/St_Johns',
  'America/Halifax',
  'America/New_York',
  'America/Chicago',
  'America/Denver',
  'America/Los_Angeles',
  'America/Anchorage',
  'Pacific/Honolulu',
  'Europe/London',
  'Europe/Berlin',
  'Europe/Kiev',
  'Europe/Istanbul',
  'Asia/Tehran',
  'Asia/Baku',
  'Asia/Kabul',
  'Asia/Karachi',
  'Asia/Kolkata',
  'Asia/Kathmandu',
  'Asia/Bishkek',
  'Asia/Yangon',
  'Asia/Bangkok',
  'Asia/Hong_Kong',
  'Australia/Eucla',
  'Asia/Seoul',
  'Australia/Darwin',
  'Australia/Brisbane',
  'Australia/Adelaide',
  'Australia/Sydney',
  'Pacific/Wake',
  'Pacific/Auckland',
  'Pacific/Chatham',
  'Pacific/Kiritimati',
];
